import React from "react";
import img13 from "../../../images/LandingPageImage/Data Security.webp";
import img11 from "../../../images/LandingPageImage/Uninterrupted Performance.webp";
import img12 from "../../../images/LandingPageImage/Always-On Expert.webp";

const FifthSection = () => {
  return (
    <>
      <style>{`
        :root {
          --max-width: 1600px;
          --content-max: 1120px;
          --card-radius: 18px;
          --accent: #2F2CD8;
        }

        .tc-wrapper {
          padding: 5rem 2rem;
          background: #f1fff8;
        }

        .tc-container {
          max-width: var(--max-width);
          margin: 0 auto;
          padding: 0 1rem;
        }

        .tc-header {
          max-width: 700px;
          margin: 0 auto 2rem auto;
          text-align: center;
        }

        .tc-header-title {
          font-size: 2rem;
          font-weight: 800;
          color: var(--accent);
          margin-bottom: 0.6rem;
          line-height: 1.08;
        }

        .tc-header-text {
          font-size: 1rem;
          line-height: 1.55;
          color: #4b5563;
          margin-bottom: 2rem;
        }

        /* Desktop grid: left column fixed, right column stacked (top + bottom) */
        .tc-grid {
          display: grid;
          grid-template-columns: 460px 1fr;
          grid-template-rows: auto auto;
          gap: 1.6rem;
          grid-template-areas:
            "left top"
            "left bottom";
          align-items: start;
          justify-content: center;
          max-width: var(--content-max);
          margin: 0 auto;
        }

        .tc-card {
          border-radius: var(--card-radius);
          // padding: 1.25rem;
          display: flex;
          flex-direction: column;
          background: #FBFAF9;
          box-sizing: border-box;
          overflow: hidden;
        }

        /* LEFT - wider feature with pinned image at bottom */
        .tc-card-left {
          grid-area: left;
          min-height: 340px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          // padding-bottom: 0;
          position: relative;
        }

        .tc-left-body {
          padding: 1rem;
        }

        .tc-left-img {
          width: 100%;
          max-width: 500px;
          margin-top: auto; 
          margin-left: auto;
          margin-right: auto;
          border-radius: 12px 12px 20px 20px;
          object-fit: cover;
          display: block;
        }

        /* RIGHT  */
        .tc-card-top {
          grid-area: top;
          min-height: 140px;
          display: flex;
          padding: 1.25rem;
          align-items: flex-start;
          width: 100%;
          // max-width: 740px;
        }

        .tc-card-bottom {
          grid-area: bottom;
          min-height: 140px;
          display: flex;
          align-items: flex-start;
          width: 100%;
          padding: 1.25rem;
          // max-width: 740px;
        }

        .tc-right-row {
          display: flex;
          gap: 1rem;
          align-items: flex-start;
          width: 100%;
        }

        .tc-right-text {
          flex: 1 1 auto;
          max-width: 100%;
        }

        .tc-right-img-wrapper {
          flex: 0 0 200px;
          display: flex;
          align-items: flex-start;
          justify-content: flex-end;
        }

        .tc-right-img {
          width: 100%;
          max-width: 165px;
          height: auto;
          border-radius: 10px;
          object-fit: cover;
        }

        .tc-title {
          font-size: 1.3rem;
          font-weight: 700;
          color: #111827;
          margin: 0 0 0.5rem 0;
        }

        .tc-text {
          font-size: 0.95rem;
          line-height: 1.5;
          color: #444444;
          margin: 0;
          font-weight: 500;
          // margin-bottom: 12px;
        }

        @media (max-width: 1024px) {
          .tc-wrapper {
            padding: 3rem 1.25rem;
          }

          .tc-grid {
            grid-template-columns: 1fr;
            grid-template-areas:
              "left"
              "top"
              "bottom";
            gap: 1.25rem;
          }

          /* LEFT card */
          .tc-card-left {
            min-height: 0;
            padding: 1rem;
            padding-bottom: 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between; 
          }

          .tc-left-body {
            order: 1;
            padding-bottom: 0.75rem;
          }

          .tc-left-img {
            order: 2;
            width: 100%;
            max-width: 420px;
            margin: 0 auto 0 auto; 
            border-radius: 12px;
            object-fit: cover;
            align-self: center;
          }

          /* RIGHT top & bottom */
          .tc-card-top,
          .tc-card-bottom {
            padding: 1rem;
            min-height: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }

          .tc-right-row {
            display: block;
          }

          .tc-right-text {
            order: 1;
            margin-bottom: 0.6rem;
          }

          .tc-right-img-wrapper {
            order: 2;
            display: flex;
            justify-content: center;
            align-items: flex-end;
            width: 100%;
            margin-top: 0;
          }

          .tc-right-img {
            max-width: 260px;
            width: 90%;
            height: auto;
            border-radius: 12px;
          }

          .tc-header-title {
            font-size: 1.8rem;
          }

          .tc-header-text {
            font-size: 0.9rem;
          }

          .tc-title {
            font-size: 1.5rem;
          }

          .tc-text {
            font-size: 1rem;
          }
        }

        /* Mobile */
        @media (max-width: 640px) {
          .tc-wrapper {
            padding: 1.8rem 0.7rem;
          }

          .tc-header {
            padding: 0 0.5rem;
          }

          .tc-header-title {
            font-size: 1.5rem;
          }

          .tc-header-text {
            font-size: 0.85rem;
          }

          .tc-card-left {
            padding: 0.75rem;
            padding-bottom: 0;
            justify-content: space-between;
          }

          .tc-left-img {
            width: 100%;
            max-width: 360px;
            margin-top: 0;
            margin-bottom: 0; 
            align-self: center;
          }

          .tc-card-top,
          .tc-card-bottom {
            padding: 0.9rem;
          }

          .tc-right-img-wrapper {
            justify-content: center;
          }

          .tc-right-img {
            max-width: 140px;
            width: 70%;
          }

          .tc-title {
            font-size: 1.3rem;
          }

          .tc-text {
            font-size: 0.8rem;
          }
        }

        @media (max-width: 420px) {
          .tc-header-title {
            font-size: 1.3rem;
          }

          .tc-header-text {
            font-size: 0.9rem;
          }

          .tc-right-img {
            max-width: 120px;
          }
        }
      `}</style>

      <section className="tc-wrapper">
        <div className="tc-container">
          <div className="tc-header">
            <h2 className="tc-header-title">Your Success, Our Priority</h2>
            <p className="tc-header-text">
              We offer a safe and reliable platform for your WhatsApp
              communication. Your messages are delivered smoothly, your data
              stays protected, and our system supports your team at every step.
            </p>
          </div>

          <div className="tc-grid">
            {/* LEFT CARD (wider) */}
            <div
              className="tc-card tc-card-left"
              style={{ background: "#ffffff" }}
            >
              <div className="tc-left-body">
                <h3 className="tc-title mt-3 mb-3">Reliable Every Time</h3>
                <p className="tc-text">
                  Experience smooth and reliable performance with our WhatsApp
                  automation tool. It’s fast, always online, and built to run
                  without interruptions, so your messages reach customers on
                  time, every time.
                </p>
              </div>

              {/* image pinned to bottom with no padding (on small screens will appear below text and flush to card bottom) */}
              <img src={img11} alt="Performance" className="tc-left-img" />
            </div>

            {/* RIGHT TOP */}
            <div
              className="tc-card tc-card-top"
              style={{ background: "#71bff723", border: "1px solid #A2D8FF" }}
            >
              <div className="tc-right-row">
                <div className="tc-right-text">
                  <h3 className="tc-title mt-4 mb-3">
                    Anytime Solution Expert
                  </h3>
                  <p className="tc-text">
                    Meet your always-on expert—available 24/7 to answer
                    questions, automate tasks, and help your customers
                    instantly. Stay quick, efficient, and responsive at all
                    times.
                  </p>
                </div>

                <div className="tc-right-img-wrapper">
                  <img src={img12} alt="Support" className="tc-right-img" />
                </div>
              </div>
            </div>

            {/* RIGHT BOTTOM */}
            <div
              className="tc-card tc-card-bottom"
              style={{ background: "#71bff723", border: "1px solid #A2D8FF" }}
            >
              <div className="tc-right-row">
                <div className="tc-right-text">
                  <h3 className="tc-title">Secure Data</h3>
                  <p className="tc-text">
                    Your data is always safe with us. We use strong security and
                    encryption to protect your messages and customer
                    information. You can focus on growing your business while we
                    keep everything secure and private.
                  </p>
                </div>

                <div className="tc-right-img-wrapper">
                  <img src={img13} alt="Security" className="tc-right-img" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FifthSection;
